/* ============================================================================
   lp-chrome-offset.js

   The three isolated landing pages (Boltline, Artline NON-PRESS, Artline PAINT
   MARKER) render the store header-group as of 2026-09-10. `.site-header` is
   position:sticky/top:0, so an in-page anchor that scrolls a target to y=0 now
   parks it underneath the header.

   Each landing page ships its own smooth-scroll implementation. Rather than
   hard-code 72px into three files, they all subtract this one measurement.

   Returns 0 when the header is absent (theme editor section preview) or is not
   actually pinned at that breakpoint, so the landing pages behave exactly as
   they did before the header existed.

   Loaded BEFORE each landing page's own scripts, non-deferred, so the value is
   available to handlers registered on DOM-ready.
   ============================================================================ */
(function (w) {
  'use strict';

  w.LPStickyChromeOffset = function () {
    var el = w.document.querySelector('.site-header');
    if (!el) return 0;

    var pos = w.getComputedStyle(el).position;
    if (pos !== 'sticky' && pos !== 'fixed') return 0;

    return el.getBoundingClientRect().height || 0;
  };
})(window);
